import { Img, Lightning } from '@lightningjs/sdk'

import { getColor, grey300, grey50, grey800, grey920 } from '../../constants/colors'
import { UniNeueBold, UniNeueRegular } from '../../constants/fonts'
import { BORDER_RADIUS } from '../../constants/general'
import { createSpeechTextForCards } from '../../utils/cardUtils'
import { HIDDEN, TvBadges, TvCardImgPlaceholder } from './templates'
import TvBaseCard from './TvBaseCard'

export default class TvOriginalCard extends TvBaseCard {
  static _template() {
    return {
      ...super._template(),
      Container: {
        w: (w) => w,
        h: (h) => h,
        rect: true,
        color: getColor(grey920),
        flex: {
          direction: 'column',
        },
        shader: {
          type: Lightning.shaders.RoundedRectangle,
          radius: BORDER_RADIUS,
        },
        ImageWrapper: {
          w: 388,
          h: 528,
          rtt: true,
          color: getColor(grey800),
          shader: {
            type: Lightning.shaders.RoundedRectangle,
            radius: [BORDER_RADIUS, BORDER_RADIUS, 0, 0],
          },
          Placeholder: {
            type: TvCardImgPlaceholder,
            imgSize: { w: 220, h: 200 },
          },
          Image: {
            w: (w) => w,
            h: (h) => h,
            texture: null,
            alpha: HIDDEN,
          },
          TopBadges: {
            w: (w) => w,
            h: (h) => h,
            flex: {
              direction: 'row',
              justifyContent: 'flex-end',
            },
            TopTrailingBadges: {
              type: TvBadges,
              flexItem: {
                marginRight: 16,
                marginTop: 16,
              },
            },
          },
        },
        Metadata: {
          w: (w) => w,
          h: 208,
          flex: {
            direction: 'column',
            padding: 16,
          },
          Details: {
            h: 36,
            flexItem: {
              marginBottom: 16,
            },
            text: {
              text: '',
              textColor: getColor(grey300),
              fontFace: UniNeueRegular,
              fontSize: 28,
              maxLines: 1,
              maxLinesSuffix: '...',
              wordWrapWidth: 0,
            },
          },
          Title: {
            h: 72,
            flexItem: {
              marginBottom: 16,
            },
            text: {
              text: '',
              textColor: getColor(grey50),
              fontFace: UniNeueBold,
              fontSize: 32,
              maxLines: 2,
              maxLinesSuffix: '...',
              wordWrapWidth: 0,
            },
          },
          Footer: {
            h: 36,
            text: {
              text: '',
              textColor: getColor(grey300),
              fontFace: UniNeueRegular,
              fontSize: 28,
              maxLines: 1,
              maxLinesSuffix: '...',
            },
          },
        },
      },
    }
  }

  get container() {
    return this.tag('Container')
  }

  get image() {
    return this.tag('Image')
  }

  get placeholder() {
    return this.tag('Placeholder')
  }

  get speechText(): string {
    return createSpeechTextForCards(
      this.data,
      ' . Select to Browse . ',
      this.cardIndex,
      this.totalCards,
    )
  }

  _init() {
    this.image.on('txLoaded', () => {
      this.placeholder.alpha = 0
      this.image.setSmooth('alpha', 1)
    })
  }

  _active() {
    this.renderCardData()
  }

  renderCardData() {
    this.container.patch({
      ImageWrapper: {
        Image: {
          texture: this.data?.preview_image?.url
            ? Img(this.data?.preview_image?.url).cover(388, 528)
            : null,
        },
        TopBadges: {
          TopTrailingBadges: {
            ...(this.data?.trailing_top_badges?.length > 0 && {
              badges: this.data.trailing_top_badges,
            }),
          },
        },
      },
      Metadata: {
        Details: {
          text: {
            text: this.data?.details?.text ?? '',
            wordWrapWidth: this.cardWidth - 16,
          },
        },
        Title: {
          text: {
            text: this.data?.title?.text ?? '',
            wordWrapWidth: this.cardWidth - 16,
          },
        },
        Footer: {
          text: {
            text: this.data?.footer?.text ?? '',
            wordWrapWidth: this.cardWidth - 16,
          },
        },
      },
    })
  }
}
